module.exports = __webpack_public_path__ + "img/bg_3.2b661eae.png";